import React, {useEffect, useState} from "react";
import "./styles/style.scss";
import {SelectButton} from "primereact/selectbutton";
import {addToDate} from "utils/time-utils";
import CalendarWrapper from "components/basic/calendar-wrapper/CalendarWrapper";
import { ChronoUnitStr } from "api/model/enums";
import { T } from "services/lang/LanguageService";
import { offsetOptions } from "../charts/utils";

type DateTimeRangeSelectionProps = {
    selectDateFrom: any;
    dateFrom: Date | undefined;
    selectDateTo: any;
    dateTo: Date | undefined;
    invalidRange: boolean;
    initialTimeOffset?: ChronoUnitStr
};

const DateTimeRangeSelection = ({selectDateFrom, dateFrom, selectDateTo, dateTo, invalidRange, initialTimeOffset}: DateTimeRangeSelectionProps) => {

    const [selectedTimeOffset, setSelectedTimeOffset] = useState<string | undefined>(initialTimeOffset);

    const handleOnSelectDateFrom = (CurrentDateFrom: Date | Date[] | undefined) => {
        if (selectedTimeOffset) {
            setSelectedTimeOffset(undefined)
        }
        selectDateFrom(CurrentDateFrom);
    };

    const handleOnSelectDateTo = (currentDateTo: Date | Date[] | undefined) => {
        if (selectedTimeOffset) {
            setSelectedTimeOffset(undefined)
        }
        selectDateTo(currentDateTo);
    };

    const onSelectButtonChange = (e: any) => {
        setSelectedTimeOffset(e.value);
    };

    useEffect(() => {
        if (selectedTimeOffset) {
            selectDateFrom(addToDate(new Date(dateTo as Date), -1, selectedTimeOffset));
        }
    }, [selectedTimeOffset]);

    return (
        <div className="dateRange ml-1">
      <span className="p-float-label justify-content-center align-text-center calendarItem">
        <CalendarWrapper id="datetimeFrom"
                         value={dateFrom}
                         onChange={(e) => handleOnSelectDateFrom(e)}
        />
        <label htmlFor="datetimeFrom">{T("label.datetime-range-selector.select-datetime-from")}</label>
          {invalidRange && <p className="error">{T("error.datetime-range-selector.must-be-before-to-date")}</p>}
      </span>
            <span className="p-float-label justify-content-center align-text-center calendarItem">
        <CalendarWrapper value={dateTo}
                         onChange={(e) => handleOnSelectDateTo(e)}
        />
        <label htmlFor="datetimeTo">{T("label.datetime-range-selector.select-datetime-to")}</label>
                {invalidRange && <p className="error">{T("error.datetime-range-selector.must-be-after-from-date")}</p>}
      </span>
            <div style={{flexWrap: "nowrap", whiteSpace: "nowrap"}}>
                <SelectButton value={selectedTimeOffset} options={offsetOptions} onChange={onSelectButtonChange}
                              className="select-button-class"/>
            </div>
        </div>
    );
};

export default DateTimeRangeSelection;
